/* Map the scroll direction */
export enum SCROLL_MAP {
    X = 'scroll-layout__content--x',
    Y = 'scroll-layout__content--y',
    XY = 'scroll-layout__content--xy',
}
